__turbopack_context__.v({
  "image": "StyledBlocksRenderer-module-scss-module__tjD6Xq__image",
  "quote": "StyledBlocksRenderer-module-scss-module__tjD6Xq__quote",
});
